export default {
  Wetransfer_Wallpaper_AdZerk_conversion: `http://e-10220.adzerk.net/e/10220/428921/e.gif?_=${Date.now()}`,
};
